import { c as _c } from "react/compiler-runtime";
import { FaroTextField } from "@components/common/faro-text-field/faro-text-field";
import { useErrorContext } from "@context-providers/error-boundary/error-handling-context";
import { updateGroupDetails } from "@store/groups/groups-slice-thunk";
import { useAppDispatch } from "@store/store-helper";
import { MIN_GROUP_NAME_LENGTH } from "@utils/group-utils";
import { ChangeGroupDetailsEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
/** Renders and updates the group name */
export function EditableGroupName(t0) {
  const $ = _c(9);
  const {
    name,
    isEditable
  } = t0;
  const {
    trackEvent
  } = useTrackEvent();
  const {
    handleErrorWithToast
  } = useErrorContext();
  const dispatch = useAppDispatch();
  let t1;
  if ($[0] !== dispatch || $[1] !== handleErrorWithToast || $[2] !== name || $[3] !== trackEvent) {
    t1 = async function onUpdateName(value) {
      trackEvent({
        name: ChangeGroupDetailsEvents.changeGroupName,
        props: {
          newNameLength: value.length
        }
      });
      ;
      try {
        await dispatch(updateGroupDetails({
          payload: {
            name: value.trim()
          }
        }));
        return value;
      } catch (t2) {
        const error = t2;
        handleErrorWithToast({
          id: `changeGroupName-${Date.now().toString()}`,
          title: "Could not change group name",
          error
        });
        return name ?? "";
      }
    };
    $[0] = dispatch;
    $[1] = handleErrorWithToast;
    $[2] = name;
    $[3] = trackEvent;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const onUpdateName = t1;
  const t2 = !isEditable;
  let t3;
  if ($[5] !== name || $[6] !== onUpdateName || $[7] !== t2) {
    t3 = <FaroTextField ariaLabel="Group name" initialValue={name} faroVariant="main" fontSize="1.125rem" isReadOnly={t2} shouldShowTooltip={true} minInputLength={MIN_GROUP_NAME_LENGTH} onConfirmed={onUpdateName} />;
    $[5] = name;
    $[6] = onUpdateName;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}